
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class LabourPriceListDialog extends _Ext.DialogBase<LabourPriceListRow, any> {
        protected getFormKey() { return LabourPriceListForm.formKey; }
        protected getIdProperty() { return LabourPriceListRow.idProperty; }
        protected getLocalTextPrefix() { return LabourPriceListRow.localTextPrefix; }
        protected getNameProperty() { return LabourPriceListRow.nameProperty; }
        protected getService() { return LabourPriceListService.baseUrl; }
        protected getDeletePermission() { return LabourPriceListRow.deletePermission; }
        protected getInsertPermission() { return LabourPriceListRow.insertPermission; }
        protected getUpdatePermission() { return LabourPriceListRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }


        protected form = new LabourPriceListForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 500;
            Config.autoHeight = false;
            q.initDetailEditor(this, this.form.PriceListDetails, Config);


            q.hideEditorLabel(this.form.PriceListDetails);

            this.form.PriceType.changeSelect2(e => { 
                var cols = this.form.PriceListDetails.cols;
                this.form.PriceListDetails.slickGrid.setColumns(cols);
               // alert(cols.length);
                if (this.form.PriceType.value != "") {
                 //   alert(this.form.PriceType.value);
                    var x = FixedCodeRow.getLookup().itemById[this.form.PriceType.value].FixedName;
                    //this.form.PriceListDetails.slickGrid.updateRow(0);
                    if (x == "PURCHASE LABOUR RATE") {
                        var temp = cols.filter(x => x.field != "SaleStdRate");
                        //this.form.PriceListDetails.setItems([]);
                        this.form.PriceListDetails.slickGrid.setColumns(temp);
                    } else if (x == "SALE LABOUR RATE") {
                        var temp = cols.filter(x => x.field != "PurStdRate")
                        //this.form.PriceListDetails.setItems([]);
                        this.form.PriceListDetails.slickGrid.setColumns(temp);

                    }
                }

            });
            
            this.form.PriceCode.changeSelect2(e => {
                var id = LabourPriceListRow.getLookup().items.filter(x => x.PriceCode.toUpperCase() == this.form.PriceCode.value)[0];
                if (id != undefined) {
                    if (id.PricelistId != null || id.PricelistId > 0) {
                        Q.notifyError("Duplicate Price Code " + this.form.PriceCode.value);
                        this.form.PriceCode.value = "";
                        return;

                    }
                }
                else {
                    this.form.PriceCode.value = this.form.PriceCode.value.toUpperCase();
                }
            });
        }
        protected onDialogOpen() {
            if (this.form.PriceType.value != "") { 
              //  alert(this.form.PriceType.value);
                var x = FixedCodeRow.getLookup().itemById[this.form.PriceType.value].FixedName;
                var cols = this.form.PriceListDetails.cols;
                //this.form.PriceListDetails.slickGrid.updateRow(0);
                if (x == "PURCHASE LABOUR RATE") {
                    cols = cols.filter(x => x.field != "SaleStdRate");
                    //this.form.PriceListDetails.setItems([]);
                    this.form.PriceListDetails.slickGrid.setColumns(cols);
                } else if (x == "SALE LABOUR RATE") {
                    cols = cols.filter(x => x.field != "PurStdRate")
                    //this.form.PriceListDetails.setItems([]);
                    this.form.PriceListDetails.slickGrid.setColumns(cols);

                }
            }
        } 
    }
}